// 위치 이용 동의(웹 공개 화면 공용) — 2026-09-16
// 근거: docs/위치기반서비스_이용약관_v1.1_게시본_2026-09-16.md(§5 안내창 확정 문구·§7 무동의 수집 정리) ·
//       docs/환자동의_문안_cp-1.4_정본_2026-09-16.md 부록 B-3·B-4·D.
// 규칙: ①화면 진입 시 자동 위치 요청 금지 ②버튼 → 안내창 + 만 14세 체크 → 동의 후에만 브라우저 위치 요청
//       ③좌표는 소수 3자리 버림(약 100m) ④동의 여부는 이 브라우저 localStorage 에만 — 서버 전송 금지 ⑤실패는 console.error(빈 catch 금지)

// 안내창 판 = 서버 계약(locationUse.noticeVersion) 값. **서버 화이트리스트와 글자까지 같아야** 확인자료에 고지판이 기록된다
// (다르면 서버가 null 로 떨어뜨림 — 2차 보안 게이트 P1-2).
// 약관 v1.1 시행일에 여기를 'lbs-v1.1-web' 으로 올린다 → 저장 키 판도 함께 올라가 전 화면 재동의(약관 게시본 §8-5).
export const LOCATION_NOTICE_VERSION = 'lbs-v1.0-web';
// 서버 이용사실 기록(위치정보법 §16②)과 같은 릴리즈로 배포 — 안내창 '보관' 문장이 게시본 §5 확정 문구가 된다.
// 서버 기록 없이 true 로 두면 안내가 사실과 달라진다(허위 고지) — 되돌릴 때는 서버와 함께.
export const LOCATION_USE_LOG_ENABLED = true;

// 화면(서비스) 구분 — 키에 포함해 화면별로 동의를 받는다(안내창이 그 화면의 이용 목적을 설명하므로)
export const LOCATION_SERVICES = {
    findClinic: { key: 'find-clinic', label: '치과 찾기' },
    findLab: { key: 'find-lab', label: '기공소 찾기' },
    asRemake: { key: 'as-remake', label: '재제작 상담 기공소 찾기' },
};

// 저장 키 = 접두사 + 안내판 + 화면. 판 문자열은 서버 전송값과 같은 상수를 쓴다(둘이 어긋나지 않게 한 곳에서 파생).
//   예) dc_locConsent_lbs-v1.0-web_find-clinic → v1.1 시행 시 dc_locConsent_lbs-v1.1-web_find-clinic (옛 키는 자연 소멸·철회 시 일괄 삭제)
const KEY_PREFIX = 'dc_locConsent_';
const keyOf = (service) => `${KEY_PREFIX}${LOCATION_NOTICE_VERSION}_${service}`;

/** 이 화면의 위치 이용 동의가 저장되어 있는가 (동의 + 만 14세 확인) */
export function readLocationConsent(service) {
    try {
        const v = JSON.parse(window.localStorage.getItem(keyOf(service)) || 'null');
        return !!(v && v.agreed === true && v.age14 === true);
    } catch (e) {
        console.error('[위치동의] 읽기 실패', service, e);
        return false;
    }
}

/** 동의 기록 저장 — 좌표는 저장하지 않는다. 실패해도 이번 이용은 진행(다음에 다시 물음) */
export function writeLocationConsent(service) {
    try {
        window.localStorage.setItem(keyOf(service), JSON.stringify({
            agreed: true, age14: true, noticeVersion: LOCATION_NOTICE_VERSION, service, at: new Date().toISOString(),
        }));
        return true;
    } catch (e) {
        console.error('[위치동의] 저장 실패', service, e);
        return false;
    }
}

/**
 * 철회 — 약관 제8조 ①의 [위치 이용 동의 철회]. 한 화면에서 눌러도 이 브라우저의 모든 화면 동의를 지운다
 * (이용자가 화면별로 따로 철회하리라 기대하기 어렵고, 철회는 넓게 보는 편이 안전).
 * @returns {boolean} 삭제 성공 여부 — 실패 시 화면은 "철회했습니다"라고 말하면 안 된다
 */
export function clearLocationConsent() {
    try {
        const keys = [];
        for (let i = 0; i < window.localStorage.length; i += 1) {
            const k = window.localStorage.key(i);
            if (k && k.startsWith(KEY_PREFIX)) keys.push(k);
        }
        keys.forEach(k => window.localStorage.removeItem(k));
        return true;
    } catch (e) {
        console.error('[위치동의] 철회(삭제) 실패', e);
        return false;
    }
}

export const LOCATION_REVOKE_OK = '철회했습니다. 다음에 현재 위치를 쓰려면 다시 동의가 필요합니다.';
export const LOCATION_REVOKE_FAIL = '철회 기록을 지우지 못했습니다. 브라우저 설정에서 이 사이트의 저장 데이터와 위치 권한을 지워 주세요.';
export const LOCATION_REGION_HINT = '지역명이나 이름을 입력해 검색하거나, 지도를 옮긴 뒤 다시 찾아 주세요.';
export const LOCATION_AGE_HINT = '만 14세 이상인 경우에만 현재 위치를 이용할 수 있습니다. 지역명·이름으로 찾아 주세요.';

/** 좌표 소수 3자리 버림(약 100m) — 서버·카카오로 나가는 위치 최소화(약관 제3조 ②). 반올림 아님 */
export function truncCoord(v) {
    const n = Number(v);
    return Number.isFinite(n) ? Math.trunc(n * 1000) / 1000 : v;
}

/** 브라우저 위치 요청 실패 문구 (빈 catch 금지 — 화면에 알리고 콘솔에도 남긴다) */
export function locationErrorMessage(err) {
    if (err?.code === 1) return '위치 권한이 거부되었습니다. 브라우저 설정에서 허용해 주세요.';
    if (err?.code === 2) return '현재 위치를 확인할 수 없습니다.';
    if (err?.code === 3) return '위치 요청이 시간 초과됐습니다.';
    return '위치 정보를 가져올 수 없습니다.';
}

/**
 * 동의 후 위치 1회 요청 — 성공 시 절삭 좌표({lat,lng})를 넘긴다. 실패는 반드시 기록·표시.
 * @param {(loc:{lat:number,lng:number})=>void} onLocation
 * @param {(msg:string)=>void} onError
 */
export function requestBrowserLocation(onLocation, onError, options = { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }) {
    if (!navigator.geolocation) {
        console.error('[위치동의] 이 브라우저는 위치 기능을 지원하지 않음');
        onError('이 브라우저는 위치 정보를 지원하지 않습니다.');
        return;
    }
    navigator.geolocation.getCurrentPosition(
        (pos) => onLocation({ lat: truncCoord(pos.coords.latitude), lng: truncCoord(pos.coords.longitude) }),
        (err) => {
            console.error('[위치동의] 위치 가져오기 실패', err?.code, err?.message);
            onError(locationErrorMessage(err));
        },
        options,
    );
}

/** 서버 계약(patientSearchHospitals 등) — 위치를 함께 보낼 때만 동봉. 좌표·식별자는 들어가지 않는다 */
export function locationUsePayload() {
    return { noticeVersion: LOCATION_NOTICE_VERSION, age14Checked: true };
}
